import { Shark } from "shark-mvc";

import NousCoreModel from "./NousCoreModel";

class Attachment extends NousCoreModel {
	description = "";
	excavationGuid = "";
	extraData = {};
	fileSize = 0;
	fileType = "";
	fileURL = "";
	folderGuid = "";
	isObsolete = false;
	name = "";
	referenceGuid = "";
	referenceType = "";
	revision = 0;
	role = "";
	tags = [];
	thumbnailURL = "";
	
	__referenceDateLabel = "";
	__fileSizeLabel = "";
	__isEditing = false;

	_cardCSSClasses = "";


	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.extraData = this.exportObjectField("extraData");
		exportData.referenceDate = this.exportDateField("referenceDate");
		exportData.tags = this.exportArrayField("tags");

		return exportData;
	}

	import (data, options) {
		super.import(data, options);

		this.importNumberField("fileSize", data.fileSize);
		this.importBooleanField("isObsolete", data.isObsolete);
		
		if (this.importDateField("referenceDate", data.referenceDate)) {
			this.__referenceDateLabel = this.referenceDate.format("DD/MM/YYYY");
		}
		
		const numberFormatter = new Intl.NumberFormat("it-IT", {maximumFractionDigits: 2});
		this.__fileSizeLabel = numberFormatter.format(this.fileSize / 1024 / 1024);

		this.__canBePreview = ["jpg", "jpeg", "png"].includes(this.fileType);

	}
}

Shark.registerModel("Attachment", Attachment);

export default Attachment;